import React, { useEffect, useState } from 'react';

import styles from './MerchantProfil.module.css';

const Header = ({ logoUrl, company }) => {
    const [validFile, setvalidFile] = useState(true);
        
    useEffect(() => {
        if (!logoUrl) {
            setvalidFile(false);
        } else {
            const img = new Image();
            img.src = logoUrl;
            img.onload = () => setvalidFile(true);
            img.onerror = () => setvalidFile(false);
        }
    }, [logoUrl])

    return (
        <div className={styles.header}>
            <div className={styles.logo} style={{ backgroundImage: `url(${!validFile ? '/TraderCard/defaultLogo.png' : logoUrl})` }} />
            <div className={styles.companyBox}>
                <h1 className={styles.company}>{company}</h1>
                <p className={styles.company}>Commerçant</p>
            </div>
        </div>
    );
};

export default Header;